var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { runtime } from '../../../runtime/Runtime';
export class PoseEnforce {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get pose() {
        return this.parent;
    }
    get app() {
        return this.pose.app;
    }
    get answer() {
        return this.pose.poseAnswer.currentlyPosedAnswer;
    }
    get secondsSincePose() {
        if (!this.answer || !this.answer.poseDate)
            return 0;
        return this.app.appClock.clock_1000.tickingTime / 1000 - this.answer.poseDate.getTime() / 1000;
    }
    get shouldTriggerEnforcementTip() {
        if (runtime.browserRuntime && !runtime.solidBrowserRuntime.browserWindow.isTabFocused)
            return false;
        if (!runtime.availablePackages.Defer)
            return false;
        const answer = this.answer;
        if (!answer || !answer.poseDate)
            return false;
        if (!!answer.completeDate)
            return false;
        if (answer.enforceTipDate)
            return true;
        if (this.secondsSincePose < 10) {
            return false;
        }
        if (this.app.media.mediaPlayer.playerChannels.channelVoice.channelInfo.silenceSinceSeconds < 7) {
            return false;
        }
        if (!this.answer.enforceTipDate) {
            runtime.runtimeScheduler.addToNextIdleStateChange(() => (answer.enforceTipDate = this.app.appClock.currentDate));
        }
        return true;
    }
    get secondsSinceTip() {
        if (!this.answer || !this.answer.enforceTipDate)
            return 0;
        return this.app.appClock.clock_1000.tickingTime / 1000 - this.answer.enforceTipDate.getTime() / 1000;
    }
    get secondsSinceLastPush() {
        if (!this.answer || !this.answer.enforcePushDate)
            return 0;
        return this.app.appClock.clock_1000.tickingTime / 1000 - this.answer.enforcePushDate.getTime() / 1000;
    }
    get shouldTriggerEnforcementPush() {
        if (runtime.browserRuntime && !runtime.solidBrowserRuntime.browserWindow.isTabFocused)
            return false;
        if (!runtime.availablePackages.Defer)
            return false;
        const answer = this.answer;
        if (!answer || !this.answer.poseDate)
            return false;
        if (!!answer.completeDate)
            return false;
        if (this.app.media.mediaPlayer.playerChannels.channelVoice.channelInfo.silenceSinceSeconds < 7) {
            return false;
        }
        if (this.answer.enforcePushDate && this.secondsSinceLastPush <= 15)
            return true;
        if (this.secondsSinceTip < 10) {
            return false;
        }
        if (this.secondsSinceLastPush > 15 && this.secondsSinceLastPush < 17) {
            return false;
        }
        if (!this.answer.enforcePushDate || this.secondsSinceLastPush > 16) {
            runtime.runtimeScheduler.addToNextIdleStateChange(() => (answer.enforcePushDate = this.app.appClock.currentDate));
        }
        return true;
    }
}
__decorate([
    computed
], PoseEnforce.prototype, "shouldTriggerEnforcementTip", null);
__decorate([
    computed
], PoseEnforce.prototype, "secondsSinceTip", null);
__decorate([
    computed
], PoseEnforce.prototype, "secondsSinceLastPush", null);
__decorate([
    computed
], PoseEnforce.prototype, "shouldTriggerEnforcementPush", null);
